import React from 'react'
import styles from './styles.module.scss'
import classNames from 'classnames'
import {
  getMTODeliveryDate,
  isTailoredProduct
} from '@components/product/mto/helpers'

type FulfillmentConfig = {
  dispatchDays: number
  labelPrefix: string
}

type FulfillmentInfoProps = {
  createdAt?: string
  fulfillment: FulfillmentConfig
  classes?: string
}

export function getFulfillmentConfig({
  isMTO,
  isBundle,
  sku
}: {
  isMTO: boolean
  isBundle: boolean
  sku?: string
}): FulfillmentConfig | null {
  if (!isMTO) return null

  const isTailored = isTailoredProduct(sku)

  if (isBundle) {
    return {
      dispatchDays: 35,
      labelPrefix: 'Sold as full bundle, dispatched by'
    }
  }

  if (isTailored) {
    return {
      dispatchDays: 35,
      labelPrefix: 'Estimated dispatch by'
    }
  }

  return {
    dispatchDays: 14,
    labelPrefix: 'Estimated dispatch by'
  }
}

function FulfillmentInfo({
  createdAt,
  fulfillment,
  classes
}: FulfillmentInfoProps) {
  return (
    <p className={classNames(styles.mtoDispatch__info, classes)}>
      <strong className={styles.mtoDispatch__title}>Made to Order:</strong>{' '}
      {fulfillment.labelPrefix}{' '}
      {getMTODeliveryDate(createdAt, fulfillment.dispatchDays)}
    </p>
  )
}

export default FulfillmentInfo
